import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import Radio, { RadioGroup } from '@8x8/oxygen-radio'
import Checkbox from '@8x8/oxygen-checkbox'

import { getAccessSettings } from '~/selectors/room-settings'
import { updateAccessSettings } from '~/actions/room-settings'
import { ColumnFlex } from '~/components/common/containers'
import { translate } from '~/core/translate'
import { SettingsContainer, SettingsTitle, StyledLegend } from './components'

const Settings = styled(ColumnFlex)`
`

const AccessSetting = styled.div`
  flex-grow: 1;
`

const IndentedContainer = styled.div`
  margin-left: 32px;
  margin-top: 8px;
`

const AccessSettings = () => {
  const dispatch = useDispatch()
  const { allowUnauthenticatedAccess, dialinEnabled } = useSelector(getAccessSettings)

  const handleAccessUpdate = useCallback(payload => {
    dispatch(updateAccessSettings({
      allowUnauthenticatedAccess: payload,
      dialinEnabled: true // Return field to intended default when changing the main option
    }))
  }, [dispatch])

  const handleDialinUpdate = useCallback(() => {
    dispatch(updateAccessSettings({
      dialinEnabled: !dialinEnabled
    }))
  }, [dispatch, dialinEnabled])

  return (
    <SettingsContainer noBorder>
      <SettingsTitle>{translate('access')}</SettingsTitle>
      <Settings>
        <AccessSetting>
          <RadioGroup onChange={handleAccessUpdate} value={allowUnauthenticatedAccess}>
            <StyledLegend>{translate('who_can_join')}</StyledLegend>
            <Radio
              label={<span>{translate('anyone_with_the_link')}</span>}
              value
              name='EVERYONE'
            />
            <Radio
              label={<span>{translate('org_members')}</span>}
              value={false}
              name='ORGANISATION_ONLY'
            />
            {!allowUnauthenticatedAccess && (
              <IndentedContainer>
                <Checkbox
                  label={translate('disable_dialin_access')}
                  isChecked={!dialinEnabled}
                  onChange={handleDialinUpdate}
                />
              </IndentedContainer>
            )}
          </RadioGroup>
        </AccessSetting>
      </Settings>
    </SettingsContainer>
  )
}

export default AccessSettings
